import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { InfoMessageModule } from 'src/app/shared/components/info-message/info-message.module';

import { RegisteredCreditCardsComponent } from "./registered-credit-cards.component";
import { FormsModule } from "@angular/forms";

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatRadioModule,
        MatIconModule,
        MatSelectModule,
        MatSlideToggleModule,
        InfoMessageModule,
        FormsModule,
        
    ],
    declarations: [RegisteredCreditCardsComponent],
    exports: [RegisteredCreditCardsComponent],
})

export class RegisteredCreditCardsModule { }
